import { Button, Container, Modal, Text } from "../../../components";
import Localization from "../../../localization";
import { Constants } from "../../../utils";
import { Images } from "../../../assets";
import React, { useRef } from "react";
import Contact from "./contact";
import { Flex } from "antd";

const View = ({
  title = "",
  desc = "",
  readUrl = "",
  sendContactRequest = async () => {},
}) => {
  const contactModalRef = useRef();

  return (
    <Container
      className="m-50-t m-100-b"
      containerStyle={{ background: "white" }}
    >
      <Text
        weight={700}
        size={"4.8rem"}
        lineHeight="4.8rem"
        children={title}
        className="d-none-mobile"
      />
      <Text
        weight={700}
        size={"3.2rem"}
        children={title}
        lineHeight="3.2rem"
        className="d-none d-block-mobile"
      />
      <Text
        size={18}
        weight={400}
        children={desc}
        type="secondary"
        className="m-40-v"
        lineHeight="2.4rem"
      />
      {!!readUrl && (
        <div className="m-90-b">
          <Button
            type="primary"
            minWidth="19rem"
            onClick={() => window.open(readUrl)}
            title={Localization.general.read_more}
          />
        </div>
      )}
      <img
        src={Images.completeHomeAlarm}
        style={{ maxWidth: "40rem", width: "100%" }}
      />
      <Text
        size={18}
        weight={500}
        className="m-40-t"
        lineHeight="2.4rem"
        type="secondary"
        children={Localization.formatString(
          Localization.unsupported_device.info,
          <Text
            level="text"
            weight={700}
            size={"inherit"}
            lineHeight="inherit"
            children={Localization.unsupported_device.info_highligh_0}
          />,
          <Text
            level="text"
            weight={700}
            size={"inherit"}
            lineHeight="inherit"
            children={Localization.unsupported_device.info_highligh_1}
          />,
          <Text
            level="text"
            weight={700}
            size={"inherit"}
            lineHeight="inherit"
            children={Localization.unsupported_device.info_highligh_2}
          />,
          <Text
            level="text"
            weight={700}
            size={"inherit"}
            lineHeight="inherit"
            children={Localization.unsupported_device.info_highligh_3}
          />
        )}
      />
      <Flex className="m-40-t" gap={"1rem"} wrap="wrap">
        <Button
          type="primary"
          minWidth="12rem"
          className="p-30-h"
          title={Localization.unsupported_device.btn_0}
          onClick={() => window.open(Constants.Project.urls.homeAlarm)}
        />
        <Button
          minWidth="12rem"
          className="p-30-h"
          title={Localization.general.tell_me_more}
          onClick={() => contactModalRef.current.open()}
        />
      </Flex>
      <Modal
        ref={contactModalRef}
        title={Localization.unsupported_device.contact_modal_title}
        children={
          <Contact
            onCancel={() => contactModalRef.current.close()}
            onSend={async (data) => {
              await sendContactRequest(data);
              contactModalRef.current.close();
            }}
          />
        }
      />
    </Container>
  );
};

export default View;
